import { Component, OnInit } from "@angular/core";
import { GeneralService } from "../../services/general.service";

@Component({
  selector: "app-categories",
  templateUrl: "./categories.component.html",
  styleUrls: ["./categories.component.scss"],
})
export class CategoriesComponent implements OnInit {
  constructor(private generalService: GeneralService) {}
  booksDetail: any = [];

  ngOnInit(): void {
    this.generalService.getBooksDetailData().subscribe((data) => {
      this.booksDetail = data;
    });
  }
}
